<template lang="pug">
  .modal.is-active
    .modal-background
    .modal-content
      .box
        h5.title {{ title }}
        .columns
          .field
            label.label {{ content }}
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Dirección Ip',
                  v-model="valor",
                )
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(@click="cerrarModal")
                    | Cancelar
                p.control
                  a.button.is-black.is-rounded(@click="modificarData")
                    | Guardar
</template>

<script>
  export default {
    name: 'ModalInputIp',
    props: {
      title: '',
      content: '',
      myplaceholder: '',

    },
    data() {
      return {
        valor: ''
      }
    },
    methods: {
      cerrarModal () {
        this.$emit('padre:modificarIp', 'close')
      },
      modificarData () {
        this.$emit('padre:modificarIp', this.valor)
        this.value = ''
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/ModalnputIp.vue